import React, {Component} from 'react';
import {PATH_TO_IMAGES} from 'config';

class SwitchFrame extends Component {
    render() {
        const {value} = this.props;

        return (
            <div className="react-select__value-image-container" data-testid={`${value}-sport-option`}>
                <img alt={value} src={`${PATH_TO_IMAGES}/ta-${value}.svg`} />
                <span className="text">{value.toUpperCase()}</span>
            </div>
        );
    }
}

export default SwitchFrame;
